<template lang="pug">
footer.footer
  div
    a(href="https://www.facebook.com/atlantafalcons/" target="_blank")
      img(:src="require('../assets/icons/facebook-f.svg')")
    a(href="https://twitter.com/AtlantaFalcons" target="_blank")
      img(:src="require('../assets/icons/twitter.svg')")
    a(href="https://www.instagram.com/atlantafalcons/" target="_blank")
      img(:src="require('../assets/icons/instagram.svg')")
    a(href="https://www.youtube.com/atlantafalcons" target="_blank")
      img(:src="require('../assets/icons/youtube.svg')")
    a(href="https://www.tiktok.com/@atlantafalcons" target="_blank")
      img(:src="require('../assets/icons/tiktok.svg')")
  div.copy &copy;{{ new Date().getFullYear() }}. Atlanta Flacons.
    a(href="https://www.atlantafalcons.com/about/privacy-policy" target="_blank") Privacy Policy
</template>

<script>
// import debug from 'debug'

// const log = debug('component:AppHeader')

export default {
  name: 'AppFooter',
}
</script>

<style lang="scss" scoped>
.footer {
  background: $brandRed;
  //bottom: 0;
  //left: 0;
  padding: 1.5em 0;
  //position: fixed;
  //right: 0;
  text-align: center;

  img {
    height: 1.5rem;
    margin: 0 .5rem;
  }

  .copy {
    font-size: .75rem;
    line-height: 1;
    padding-top: .75rem;
  }
  .copy a {
    display: block;
    color: #fff;
    opacity: 0.5;
    margin-top: 0.3rem;
  }

  @media (min-height: 940px) and (min-width: 640px) {
    bottom: 0;
    left: 0;
    position: fixed;
    right: 0;
  }
}
</style>
